import ScalarIconEnvelopeSimple_vue_vue_type_script_setup_true_lang_default from "./ScalarIconEnvelopeSimple.vue.script.js";
//#region src/components/ScalarIconEnvelopeSimple.vue
var ScalarIconEnvelopeSimple_default = ScalarIconEnvelopeSimple_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconEnvelopeSimple_default as default };

//# sourceMappingURL=ScalarIconEnvelopeSimple.js.map